<div class="app-content content">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
        <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
      </div>
      <div class="content-body">
        <section id="pills-elements">
          <div class="row" matchHeight="card">
            <div class="col-xl-12 col-lg-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Selecciona el catálogo</h4>
                </div>
                <div class="card-content">
                  <ng-template #modalHabilidad>
                    <div class="modal-content">
                      <div class="modal-header bg-blue4">
                          <h4 class="modal-title text-bold-600" id="myModalLabel22">{{title}}</h4>
                      </div>
                      <div class="modal-body">
                          <p class="media-body font-medium-2">{{message}}</p> 
                          <br>
                          <form class="form form-horizontal" [formGroup]="habilidadForm">
                              <div class="form-body">
                                <div class="form-group row mx-auto col-12">
                                  <input type="text" class="form-control" placeholder="Descripción" formControlName="description" 
                                  [ngClass]="{ 'is-invalid': j.description.errors && (j.description.dirty) }">
                                  <small class="form-text text-muted danger" *ngIf="j.description.errors" class="invalid-feedback">
                                      <div *ngIf="j.description.errors && (j.description.dirty)">
                                      Completa esta campo correctamente</div>
                                  </small>
                                </div>
                              </div>
                              <div class="form-actions text-center">
                                  <button type="button" class="btn btn-outline-secondary btn-min-width mr-1"
                                  (click)="closeModal()"><i class="feather ft-x"></i> Cancelar</button>
                                  <button type="submit" class="btn btn-success font-medium-1" (click)="deployHabActionButton()">
                                  <i class="feather ft-check"></i> Guardar</button>
                              </div>
                          </form>
                      </div>
                  </div>
                  </ng-template>
                  <ng-template #modalConocimiento>
                    <div class="modal-content">
                      <div class="modal-header bg-blue4">
                          <h4 class="modal-title text-bold-600" id="myModalLabel22">{{title}}</h4>
                      </div>
                      <div class="modal-body">
                          <p class="media-body font-medium-2">{{message}}</p> 
                          <br>
                          <form class="form form-horizontal" [formGroup]="conocimientoForm">
                              <div class="form-body">
                                <div class="form-group row mx-auto col-12">
                                  <input type="text" class="form-control" placeholder="Descripción" formControlName="description" 
                                  [ngClass]="{ 'is-invalid': f.description.errors && (f.description.dirty) }">
                                  <small class="form-text text-muted danger" *ngIf="f.description.errors" class="invalid-feedback">
                                      <div *ngIf="f.description.errors && (f.description.dirty)">
                                      Completa esta campo correctamente</div>
                                  </small>
                                </div>
                              </div>
                              <div class="form-actions text-center">
                                  <button type="button" class="btn btn-outline-secondary btn-min-width mr-1"
                                  (click)="closeModal()"><i class="feather ft-x"></i> Cancelar</button>
                                  <button type="submit" class="btn btn-success font-medium-1" (click)="deployActionButton()">
                                  <i class="feather ft-check"></i> Guardar</button>
                              </div>
                          </form>
                      </div>
                  </div>
                  </ng-template>
                  <div class="table-responsive card-body">
                    <div class="row">
                      <div class="col-sm-3">  
                        <div class="list-group">
                          <button class="list-group-item list-group-item-action" [ngClass]="{'active bg-blue4': catalogoConocimientos}" (click)="selectCatalogoConocimientos()">
                            <h4 class="text-bold-600" [ngClass]="{'white': catalogoConocimientos}">Habilidades técnicas</h4></button>
                        </div>
                      </div>
                      <div class="col-sm-3">  
                        <div class="list-group">
                          <button class="list-group-item list-group-item-action" [ngClass]="{'active bg-blue4': !catalogoConocimientos}" (click)="selectCatalogoHabilidades()">
                            <h4 class="text-bold-600" [ngClass]="{'white': !catalogoConocimientos}">Habilidades socioemocionales</h4></button>
                        </div>
                      </div>
                    </div>
                    <br>

                    <div class="row"> 
                      <div class="col-md-12 text-left">
                        <h4 class="text-bold-600">Buscar</h4>
                      </div>
                    </div>

                    <div class="row"> 
                      <div class="col-md-4 text-left">
                        <div class="form-group position-relative">
                          <input type="text" class="form-control round border-info font-medium-2 card-title" placeholder="Descripción del registro"
                          [ngbTypeahead]="catalogoConocimientos ? searchOnFocusConocimiento : searchOnFocusHabilidad" [(ngModel)]="model" (focus)="focus$.next($event.target.value)" #instance="ngbTypeahead"/>
                          <div class="form-control-position">
                              <i class="la la-search text-size-base text-muted la-rotate-270"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <button type="button" class="btn btn-navy" (click)=" catalogoConocimientos ? searchConocimiento() : searchHabilidad()">
                            <h5 class="text-white font-bold-600 font-medium-1 text-bold-600 text-uppercase">Buscar</h5></button>
                        </div>
                      </div>
                      <div class="col-md-6 text-right">
                        <div class="btn-group mb-1">
                          <button type="button" class="btn btn-success font-medium-2" (click)="catalogoConocimientos ? addConocimiento(modalConocimiento) : addHabilidad(modalHabilidad)">
                            <i class="feather ft-plus"></i>Nuevo registro</button>
                        </div>
                      </div>
                    </div>

                    <div class="row" *ngIf="catalogoConocimientos && !showSearchedConocimiento">
                      <div class="col-md-12"> 
                        <div *ngIf="!responseConocimientos || responseConocimientos?.length === 0"
                          class="bs-callout-info callout-round callout-bordered mt-1">
                            <div class="media align-items-stretch">
                              <div class="d-flex align-items-center media-left media-middle bg-info callout-arrow-left position-relative p-2">
                                <i class="la la-ban white font-medium-5"></i>
                              </div>
                              <div class="media-body p-1">
                                <h4 class="info">Aún no existen conocimientos registrados</h4>
                                <p>Comienza a registrar nuevos conocimientos y consúltalos aquí.</p>
                              </div>
                            </div>
                        </div>
                        <table *ngIf="responseConocimientos || responseConocimientos?.length > 0" class="table table-column table-hover">
                          <thead class="thead bg-blue1">
                            <tr>   
                              <th scope="col">
                                <h5 class="text-bold-600">Descripción</h5></th> 
                                <th scope="col">
                                  <h5 class="text-bold-600">Editar</h5></th> 
                              </tr>
                          </thead>
                          <tbody *ngFor="let conocimiento of responseConocimientos; let i = index;">
                            <tr class="ng-star-inserted" [ngClass]="{'bg-success bg-lighten-5': isFirst && i===0}">
                              <td scope="row">{{ conocimiento.descripcion }}</td>                  
                              <td scope="row" class="text-center"> 
                                <button type="button" class="btn btn-icon btn-info mr-1" (click)="updateConocimiento(modalConocimiento,conocimiento)"
                                triggers="hover:click:hover" placement="top"
                                ngbPopover="Introduce los nuevos datos en los campos de texto correspondientes y luego presiona este botón para actualizar la infromación."
                                popoverTitle="Editar registro">
                                  <i class="icon-pencil"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    
                    <div class="row" *ngIf="catalogoConocimientos && showSearchedConocimiento && responseConocimientoCopy">
                      <div class="col-md-12"> 
                        <div *ngIf="!responseConocimientos || responseConocimientos?.length === 0"
                          class="bs-callout-info callout-round callout-bordered mt-1">
                            <div class="media align-items-stretch">
                              <div class="d-flex align-items-center media-left media-middle bg-info callout-arrow-left position-relative p-2">
                                <i class="la la-ban white font-medium-5"></i>
                              </div>
                              <div class="media-body p-1">
                                <h4 class="info">Aún no existen conocimientos registrados</h4>
                                <p>Comienza a registrar nuevos conocimientos y consúltalos aquí.</p>
                              </div>
                            </div>
                        </div>
                        <table *ngIf="responseConocimientoCopy" class="table table-column table-hover">
                          <thead class="thead bg-blue1">
                            <tr>   
                              <th scope="col">
                                <h5 class="text-bold-600">Descripción</h5></th> 
                                <th scope="col">
                                  <h5 class="text-bold-600">Editar</h5></th> 
                              </tr>
                          </thead>
                          <tbody>
                            <tr class="ng-star-inserted">
                              <td scope="row">{{ responseConocimientoCopy.descripcion }}</td>                  
                              <td scope="row" class="text-center"> 
                                <button type="button" class="btn btn-icon btn-info mr-1" (click)="updateConocimiento(modalConocimiento,responseConocimientoCopy)"
                                triggers="hover:click:hover" placement="top"
                                ngbPopover="Introduce los nuevos datos en los campos de texto correspondientes y luego presiona este botón para actualizar la infromación."
                                popoverTitle="Editar registro">
                                  <i class="icon-pencil"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="row" *ngIf="!catalogoConocimientos && !showSearchedHabilidad">
                      <div class="col-md-12"> 
                        <div *ngIf="!responseHabilidades || responseHabilidades?.length === 0"
                          class="bs-callout-info callout-round callout-bordered mt-1">
                            <div class="media align-items-stretch">
                              <div class="d-flex align-items-center media-left media-middle bg-info callout-arrow-left position-relative p-2">
                                <i class="la la-ban white font-medium-5"></i>
                              </div>
                              <div class="media-body p-1">
                                <h4 class="info">Aún no existen habilidades registradas</h4>
                                <p>Comienza a registrar nuevas habilidades y consúltalas aquí.</p>
                              </div>
                            </div>
                        </div>
                        <table *ngIf="responseHabilidades || responseHabilidades?.length > 0" class="table table-column table-hover">
                          <thead class="thead bg-blue1">
                            <tr>   
                              <th scope="col">
                                <h5 class="text-bold-600">Descripción</h5></th> 
                                <th scope="col">
                                  <h5 class="text-bold-600">Editar</h5></th> 
                              </tr>
                          </thead>
                          <tbody *ngFor="let habilidad of responseHabilidades; let i = index;">
                            <tr class="ng-star-inserted" [ngClass]="{'bg-success bg-lighten-5': isFirstHabilidad && i===0}">
                              <td scope="row">{{ habilidad.descripcion }}</td>                  
                              <td scope="row" class="text-center"> 
                                <button type="button" class="btn btn-icon btn-info mr-1" (click)="updateHabilidad(modalHabilidad,habilidad)"
                                triggers="hover:click:hover" placement="top"
                                ngbPopover="Introduce los nuevos datos en los campos de texto correspondientes y luego presiona este botón para actualizar la infromación."
                                popoverTitle="Editar registro">
                                  <i class="icon-pencil"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="row" *ngIf="!catalogoConocimientos && showSearchedHabilidad && responseHabilidadCopy">
                      <div class="col-md-12"> 
                        <div *ngIf="!responseHabilidades || responseHabilidades?.length === 0"
                          class="bs-callout-info callout-round callout-bordered mt-1">
                            <div class="media align-items-stretch">
                              <div class="d-flex align-items-center media-left media-middle bg-info callout-arrow-left position-relative p-2">
                                <i class="la la-ban white font-medium-5"></i>
                              </div>
                              <div class="media-body p-1">
                                <h4 class="info">Aún no existen habilidades registradas</h4>
                                <p>Comienza a registrar nuevas habilidades y consúltalas aquí.</p>
                              </div>
                            </div>
                        </div>
                        <table *ngIf="responseHabilidadCopy"class="table table-column table-hover">
                          <thead class="thead bg-blue1">
                            <tr>   
                              <th scope="col">
                                <h5 class="text-bold-600">Descripción</h5></th> 
                                <th scope="col">
                                  <h5 class="text-bold-600">Editar</h5></th> 
                              </tr>
                          </thead>
                          <tbody>
                            <tr class="ng-star-inserted">
                              <td scope="row">{{ responseHabilidadCopy.descripcion }}</td>                  
                              <td scope="row" class="text-center"> 
                                <button type="button" class="btn btn-icon btn-info mr-1" (click)="updateHabilidad(modalHabilidad,responseHabilidadCopy)">
                                  <i class="icon-pencil"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="row"><br><br><br></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  